import { Chip, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

function Hours({ children }: Props) {
  return (
    <Chip radius="xl" color="light-gray" className="mr-2 px-3 py-1">
      <Typography color="dark" variant="caption" className="flex items-center">
        {children}
      </Typography>
    </Chip>
  );
}

export default observer(Hours);
